import React, { useState } from 'react';
import { Check } from 'lucide-react';

const Stepper = ({ steps, currentStep = 0 }) => {
  return (
    <div className="w-full py-8">
      <div className="flex items-center justify-between max-w-4xl mx-auto">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center flex-1">
              {/* Step Circle */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all ${
                  index < currentStep
                    ? 'bg-teal-600 text-white'
                    : index === currentStep
                    ? 'bg-teal-600 text-white ring-4 ring-teal-100'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {index < currentStep ? <Check size={20} /> : index + 1}
              </div>
              {/* Step Label */}
              <span
                className={`mt-2 text-xs md:text-sm text-center font-medium ${
                  index <= currentStep ? 'text-gray-900' : 'text-gray-500'
                }`}
              >
                {step}
              </span>
            </div>
            
            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-1 mx-2 mt-[-24px]">
                <div
                  className={`h-full rounded transition-all ${
                    index < currentStep ? 'bg-teal-600' : 'bg-gray-200'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
